import React, { Component, PropTypes } from 'react';
import { markdown } from 'markdown';
import css from './confirm.scss';

import InputSubmit from  './input/submit';

export default class ConfirmDialog extends Component {
	static propTypes = {};

	static defaultProps = {};

	constructor(props) {
		super();

		this.promiseResolve = function() {};
		this.promiseReject = function() {};

		this.newPromise();
		this._handleEscKey = this._handleEscKey.bind(this);

		this.state = {
			show: false,
			text: 'Are you sure?',
			confirmText: 'Confirm',
			cancelText: 'Cancel',
			openLinkOnConfirm: false,
		};
	}

	render() {
		let className = 'confirm-dialog';

		if (this.state.show) {
			className += ' confirm-dialog--show';
		}

		return (
			<div className={className} onClick={(e) => this.close(e)}>
				<div className='confirm-dialog__dialog' onClick={(e) => e.stopPropagation()}>
					<div className='confirm-dialog__dialog__content' dangerouslySetInnerHTML={{ __html: markdown.toHTML(this.state.text) }} />

					<div className='confirm-dialog__dialog__actions'>
						{(!!this.state.confirmText) && (
							(this.state.openLinkOnConfirm) && (
								<a href={this.state.openLinkOnConfirm} target='_blank' className='button' onClick={() => this.handleOK()}>{this.state.confirmText}</a>
							) || (
								<button onClick={this.handleOK.bind(this)} ref='confirm'>{this.state.confirmText}</button>
							)
						)}
						{(!!this.state.cancelText) && (
							<button onClick={this.handleCancel.bind(this)} className='button--dark'>{this.state.cancelText}</button>
						)}
					</div>
				</div>
			</div>
		);
	}

	handleOK(e) {
		e && e.preventDefault();
		this.promiseResolve();
		this.setState({ ...this.state, show: false });
	}

	handleCancel(e) {
		e.preventDefault();
		this.promiseReject({ status: 'CANCELLED' });
		this.setState({ ...this.state, show: false });
	}

	close(e) {
		e.preventDefault();
		e.stopPropagation();
		this.promiseReject({ status: 'CLOSED' });
		this.setState({ ...this.state, show: false });
	}

	newPromise() {
		this.promise = new Promise((resolve, reject) => {
			this.promiseResolve = resolve;
			this.promiseReject = reject;
		});
	}

	confirm(text, confirmText = 'Confirm', cancelText = 'Cancel', openLinkOnConfirm = false) {
		this.newPromise();
		this.setState({
			...this.state,
			show: true,
			text,
			confirmText,
			cancelText,
			openLinkOnConfirm,
		});
		this.refs.confirm && this.refs.confirm.focus();

		document.addEventListener('keydown', this._handleEscKey, false);

		this.promise.then(() => {
			document.removeEventListener('keydown', this._handleEscKey, false);
		}).catch(() => {
			document.removeEventListener('keydown', this._handleEscKey, false);
		});

		return this.promise;
	}

	_handleEscKey(e) {
		if (e.keyCode === 27) {
			this.handleCancel(e);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/confirm.js
 **/